export default __webpack_public_path__ + "static/media/guest-ranger-logo-white.bc5f7d4d.svg";